import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedbackService, ReportService } from '@app/core/services';
import { CellTransform, TableConfig } from '@app/interfaces/table';
import { UserListModel } from '@app/modules/fund-management/account-user/user-list.model';
import { BaseListComponent } from '../../base-list.component';
import { TableComponent } from '../../table/table.component';
import { SavedReportFilterUserService } from '../services/saved-report-filter-user.service';

@Component({
	selector: 'saved-report-filter-user-selection',
	templateUrl: './user-selection.component.html',
	styleUrls: ['./user-selection.component.less'],
	standalone: true,
	imports: [MatFormFieldModule, MatInputModule, MatIconModule, TableComponent, MatDialogModule, MatButtonModule],
})
export class SavedReportFilterUserSelectionComponent extends BaseListComponent<UserListModel, SavedReportFilterUserService> implements OnInit {
	entityData: UserListModel[] = [];
	selectedUsers: UserListModel[] = [];
	entityName: 'User';
	listingPagePath = '/lsb/saved-report-filter';

	config: TableConfig<UserListModel> = {
		...this.config,
		onRowClick: null,
		columns: [
			{
				header: 'Name',
				key: 'FullName',
			},
			{
				header: 'Role(s)',
				key: 'Role',
				transform: ({ value }: CellTransform<UserListModel>): string => (Array.isArray(value) ? value.join(', ') : value ? `${value}` : ''),
			},
		],
		showRowSelect: true,
		defaultSortField: 'FullName',
	};

	constructor(
		protected readonly listService: SavedReportFilterUserService,
		protected readonly dialog: MatDialog,
		protected readonly feedbackService: FeedbackService,
		protected readonly route: ActivatedRoute,
		protected readonly router: Router,
		protected readonly reportService: ReportService,
		public dialogRef: MatDialogRef<SavedReportFilterUserSelectionComponent>
	) {
		super(dialog, feedbackService, route, router, reportService);
	}

	ngOnInit(): void {
		this.listService.getUsers().subscribe((data) => {
			this.entityData = data.data;
		});
	}

	onSelectionChanged(selected: any[]): void {
		this.selectedUsers = selected;
	}

	cancel(): void {
		this.dialogRef.close();
	}

	saveSelectedUsers(): void {
		const userIds = this.selectedUsers.map((user) => user.Id);
		this.dialogRef.close(userIds);
	}
}
